import * as THREE from "three";
import Experience from "../../../Experience.js";
import vertexShader from "./shaders/planktonVertexShader.glsl";
import fragmentShader from "./shaders/planktonFragmentShader.glsl";

export default class Plankton {
    constructor(bounds, count = 1000) {
        this.experience = new Experience();
        this.resources = this.experience.resources;
        this.bounds = bounds;
        this.count = count;

        this._setGeometry();
        this._setMaterial();
        this._setMesh();
    }

    _setGeometry() {
        this.geometry = new THREE.BufferGeometry();

        const positions = new Float32Array(this.count * 3);
        const rotations = new Float32Array(this.count);
        const radius = 110;

        for (let i = 0; i < this.count; i++) {
            const i3 = i * 3;

            // Cylinder distribution
            const angle = Math.random() * Math.PI * 2;
            const r = Math.sqrt(Math.random()) * radius; // Uniform distribution in circle

            positions[i3] = Math.cos(angle) * r + this.bounds.center.x;
            positions[i3 + 1] =
                Math.random() * (this.bounds.max.y - this.bounds.min.y) +
                this.bounds.min.y;
            positions[i3 + 2] = Math.sin(angle) * r + this.bounds.center.z;

            rotations[i] = Math.random() * Math.PI * 2;
        }

        this.geometry.setAttribute(
            "position",
            new THREE.BufferAttribute(positions, 3),
        );
        this.geometry.setAttribute(
            "aRotation",
            new THREE.BufferAttribute(rotations, 1),
        );
    }

    _setMaterial() {
        const planktonTexture = this.resources.items.planktonTexture;
        // planktonTexture.flipY = false;

        this.material = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,
            transparent: true,
            depthWrite: false,
            blending: THREE.AdditiveBlending,
            uniforms: {
                uTimeP: { value: 0 },
                uPixelRatio: { value: this.experience.sizes.pixelRatio },
                uSize: { value: 150 },
                uTexture: { value: planktonTexture },
            },
        });
    }

    _setMesh() {
        this.mesh = new THREE.Points(this.geometry, this.material);
    }

    update() {
        this.material.uniforms.uTimeP.value =
            this.experience.time.elapsed * 0.001;
    }
}
